import { useState } from 'react';
import { Dialog, DialogContent, Typography, Box, IconButton } from '@mui/material';
import { QrReader } from 'react-qr-reader'; // Ojo con la versión importada
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { updateBookingStatus } from '../../../controllers/company/MerchantBookingController';

export default function ScanQrModal({ open, onClose, onScanSuccess }) {
    const [scanned, setScanned] = useState(false);

    const handleResult = async (result, error) => {
        if (!!result && !scanned) {
            setScanned(true); // Evitar lecturas múltiples
            const uuid = result?.text;
            
            try{
                const status = 'completed';
                const response = await updateBookingStatus(uuid,status);
                if(response.success === true){
                    alert("✅ Check-in Exitoso");
                    onScanSuccess(); // Recarga el dashboard
                    onClose();
                }
                else{
                    alert("❌ Error: No se pudo cambiar el estatus.");
                    setScanned(false);
                }
                
            }catch(error){
                alert("❌ Error: QR no válido o cita no encontrada");
                setScanned(false);
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <Box display="flex" justifyContent="flex-end" p={1}>
                <IconButton onClick={onClose}><FontAwesomeIcon icon={faTimes}/></IconButton>
            </Box>
            <DialogContent sx={{ textAlign: 'center', pb: 4 }}>
                <Typography variant="h6" gutterBottom>Escanear Ticket</Typography>
                <Box sx={{ mt: 2, bgcolor: 'black', borderRadius: 2, overflow: 'hidden' }}>
                    <QrReader
                        onResult={handleResult}
                        constraints={{ facingMode: 'environment' }} // Usa cámara trasera en móvil
                        style={{ width: '100%' }}
                    />
                </Box>
                <Typography variant="caption" display="block" mt={2}>
                    Acerca el código QR a la cámara
                </Typography>
            </DialogContent>
        </Dialog>
    );
}